const socketsByRole = new Map();

export function setSocket(role = 'player', socket = null) {
  if (!role) return;
  if (socket) {
    socketsByRole.set(role, socket);
  } else {
    socketsByRole.delete(role);
  }
}

export function getSocket(role = 'player') {
  return socketsByRole.get(role) || null;
}

export function clearSocket(role = 'player', socket = null) {
  if (!role) return;
  if (socket && socketsByRole.get(role) !== socket) return;
  socketsByRole.delete(role);
}

export default {
  setSocket,
  getSocket,
  clearSocket,
};
